import { COLORS } from '@btime/constants'
import React from 'react'

import { PermissionChecker } from '../../session'
import { getQueryParam } from '../../../packages/kiti/utils/helpers/url'
import { useGetAllServiceOrders } from '../../../containers/serviceOrders/SelectAllServiceOrdersLink'
import { useLocalStorageWatcher } from '../../../utils/helpers/localStorage'
import AddNewButton from '../list/AddNewButton'
import ConfigsLoader from '../../../containers/configs/_load/ConfigsLoader'
import ControlBar from '../list/ControlBar'
import FilterWrapper from '../list/filters/FilterWrapper'
import Kanban from '../../../containers/screens/kanban/Kanban'
import ListCounter from '../list/ListCounter'
import MultiRowsActions from './MultiRowsActions'
import MultiSelectHandler from '../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import MultiSelectToggler from '../../../components/actions/MultiSelectToggler'
import PageHeader from '../list/PageHeader'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import ServiceOrderCardV2 from '../../../containers/serviceOrders/ServiceOrderCardV2'
import ServiceOrdersLoader from './_load/ServiceOrdersLoader'
import SideMenuTemplate from '../../../components/templates/v2/SideMenuTemplate'
import ServiceOrderNotificationAlert from '../_common/ServiceOrderNotificationAlert'

const ServiceOrdersKanbanPage = ({ id }) => {
  useLocalStorageWatcher('SERVICE_ORDERS_LAST_SCREEN', `kanban/${id}`)
  const demo = getQueryParam('d')

  return (
    <SideMenuTemplate bgColor={COLORS.white}>
      <Separator weight={6} flex={1}>
        <PermissionChecker permission="listServiceOrder">
          <ConfigsLoader>
            <ServiceOrderNotificationAlert>
              <FilterWrapper>
                <MultiSelectHandler>
                  <PageHeader />
                  <ControlBar hideFastFilters selectedScreen={`kanban/${id}`}>
                    <MultiSelectToggler />
                  </ControlBar>
                  <Kanban
                    screenId={id}
                    Loader={ServiceOrdersLoader}
                    Card={ServiceOrderCardV2}
                    Counter={props => <ListCounter {...props} flexiblePollInterval={demo ? 5000 : 30000} />}
                    useGetAll={useGetAllServiceOrders}
                  />
                  <MultiRowsActions />
                </MultiSelectHandler>
                <AddNewButton />
              </FilterWrapper>
            </ServiceOrderNotificationAlert>
          </ConfigsLoader>
        </PermissionChecker>
      </Separator>
    </SideMenuTemplate>
  )
}

export default ServiceOrdersKanbanPage
